
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170.4","height":"170.4","viewBox":"0 0 45.085 45.085","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 22.55C0 35 10.093 45.093 22.543 45.093S45.086 35 45.086 22.55 34.993.008 22.543.008 0 10.1 0 22.55","fill":"#324a5e"}}),_c('path',{attrs:{"d":"M34.657 35.39H10.323a.676.676 0 01-.677-.676V10.38a.677.677 0 011.353 0v23.657h23.658a.676.676 0 110 1.353","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.175 25.69h-2.753v6.502h2.753z","fill":"#ff7058"}}),_c('path',{attrs:{"d":"M20.045 23.38h-2.753v8.82h2.753z","fill":"#ffd05b"}}),_c('path',{attrs:{"d":"M24.916 21.64h-2.753v10.551h2.753z","fill":"#ff7058"}}),_c('path',{attrs:{"d":"M29.786 23.38h-2.753v8.82h2.753z","fill":"#ffd05b"}}),_c('path',{attrs:{"d":"M34.657 19.94h-2.753v12.251h2.753z","fill":"#ff7058"}}),_c('g',[_c('path',{attrs:{"d":"M36.143 12.04l-4.475.99 1.467 1.467-4.679 4.68-5.94-5.94a.507.507 0 00-.716 0l-8.36 8.36a.507.507 0 10.717.717l8.001-8.001 5.94 5.939c.197.198.519.198.717 0l5.038-5.038 1.3 1.301z","fill":"#84dbff"}})])])
          )
        }
      }
    